import { base64ToFile } from "features/shared/hooks/useDocumentImagesUpload";
import { useAppStore } from "store/store";

export interface PageAnalyticsParams {
  path: string;
  title: string;
  location: string;
}

const handleCapturedDocumentScan = (
  results: string[],
  uploadFiles: (
    images: File[],
    additionalPaxSessionIds?: string[],
    pageIndexToProcess?: number
  ) => Promise<void>,
  fileName?: string,
  additionalPaxSessionIds?: string[],
  pageIndexToProcess?: number | undefined
) => {
  useAppStore.getState().setProcessedFileName(null);
  useAppStore.getState().setProcessingMayTakeLong(null);

  const images: File[] = results.map((result) => {
    return base64ToFile(
      result,
      fileName ? fileName : "captured_image.jpeg",
      "image/jpeg"
    );
  });

  uploadFiles(images, additionalPaxSessionIds, pageIndexToProcess);
};

export default handleCapturedDocumentScan;
